
import PropTypes from "prop-types";
import { useEffect, useRef } from "react";
import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";

export const GSAPAnimationGalleryGrid = ({ className = "", children }) => {
  const galleryGridRef = useRef(null);

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    const ctx = gsap.context(() => {
      const boxes = gsap.utils.toArray(".itemG");
      boxes.forEach((box, i) => {
        gsap.set(box, { opacity: 0, position: "relative", top: 40 });
        gsap.to(box, {
          opacity: 1,
          top: 0,
          ease: "cubic-bezier(.17,.17,.30,1.00)",
          duration: 1.0,
          scrollTrigger: {
            trigger: box,
            start: "top bottom",
            toggleActions: "play none none reverse",
          },
        });
      });
    }, galleryGridRef);

    return () => {
      ctx.revert();
      ctx.kill();
    };
  }, []);

  return (
    <div ref={galleryGridRef} className={className}>
      {children}
    </div>
  );
};

GSAPAnimationGalleryGrid.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};
